export default __webpack_public_path__ + "static/media/keep-dry.736af981.svg";